import { Injectable } from '@angular/core';
import { HttpService } from '../http-service/http.service';
import { UrlConnectionEnum } from '../../enums/url-connection.enum';

@Injectable({
  providedIn: 'root',
})
export class DoctorService {

    constructor(private httpService: HttpService) { }


    async getDoctors(filters = {}){
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(true);


                this.httpService.get(UrlConnectionEnum.GET_DOCTORS, filters, config).subscribe({
                    next: (data) => {
                        if(data.result){
                            resolve(data.result);
                        }else{
                          resolve(data)
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });

            } catch (error) {
                reject(error);
            }
        });
    }

    async getDoctorDetails(params = {}){
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(true);


                this.httpService.get(UrlConnectionEnum.GET_DOCTOR_DETAILS, params, config).subscribe({
                    next: (data) => {
                        if(data.result){
                            resolve(data.result);
                        }else{
                          resolve(data)
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });

            } catch (error) {
                reject(error);
            }
        });
    }

    async updateDoctor(doctor:any){
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(true);
                let body = doctor;

                this.httpService.put(UrlConnectionEnum.UPDATE_DOCTOR, body, config).subscribe({
                    next: (data) => {
                        if(data.result){
                            resolve(data.result);
                        }else{
                        resolve(data)
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });

            } catch (error) {
                reject(error);
            }
        });
    }


}
